import { addProp } from "@pnp/odata";
import { _Web } from "../webs/types.js";
import { UserCustomActions } from "./types.js";
addProp(_Web, "userCustomActions", UserCustomActions);
//# sourceMappingURL=web.js.map